import React from 'react'
import './style.css'
import Button from '../CtaButton'

const NewTeamSection = ({ shortHeading, mainHeading, description }) => {
    return (
        <>
            <section className="hire-page-team-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="new-team-section-content-box">
                                <h2 className='low-top-heading'>{shortHeading}</h2>
                                <p className='new-team-section-heading'>{mainHeading}</p>
                                <p className="description-text">{description}</p>
                            </div>
                        </div>
                    </div>
                    <div className="row g-4">
                        {/* Team Card 1 */}
                        <div className="col-md-4">
                            <div className="hire-page-team-section-card p-4 bg-white shadow-sm text-center h-100">
                                <img src="/images/home-page-icons/male-avatar.png" alt="Samuel L." className="rounded-circle mb-3" />
                                <h5 className="fw-bold">Sr. ML Engineer</h5>
                                <p className="text-muted mb-1">Samuel L.</p>
                                <p className="text-secondary small mb-3">12 years of experience</p>
                                <div className="d-flex justify-content-center flex-wrap gap-2 mb-3">
                                    <span className="badge bg-light text-dark">PyTorch</span>
                                    <span className="badge bg-light text-dark">TensorFlow</span>
                                </div>
                                <ul className="list-unstyled text-start small m-0">
                                    <li>✔ AWS Certified Machine Learning – Specialty</li>
                                    <li>✔ Google Cloud Professional Machine Learning Engineer</li>
                                </ul>
                            </div>
                        </div>
                        {/* Team Card 2 */}
                        <div className="col-md-4">
                            <div className="hire-page-team-section-card p-4 bg-white shadow-sm text-center h-100">
                                <img src="/images/home-page-icons/female-avatar.png" alt="Maria B." className="rounded-circle mb-3" />
                                <h5 className="fw-bold">Sr. Data Engineer</h5>
                                <p className="text-muted mb-1">Maria B.</p>
                                <p className="text-secondary small mb-3">8 years of experience</p>
                                <div className="d-flex justify-content-center flex-wrap gap-2 mb-3">
                                    <span className="badge bg-light text-dark">Apache Spark</span>
                                    <span className="badge bg-light text-dark">BigQuery</span>
                                </div>
                                <ul className="list-unstyled text-start small m-0">
                                    <li>✔ Google Cloud Professional Data Engineer</li>
                                    <li>✔ Databricks Certified Data Engineer Professional</li>
                                </ul>
                            </div>
                        </div>
                        {/* Team Card 3 */}
                        <div className="col-md-4">
                            <div className="hire-page-team-section-card p-4 bg-white shadow-sm text-center h-100">
                                <img src="/images/home-page-icons/male-avatar.png" alt="Juan G." className="rounded-circle mb-3" />
                                <h5 className="fw-bold">Sr. MLOps Engineer</h5>
                                <p className="text-muted mb-1">Juan G.</p>
                                <p className="text-secondary small mb-3">10 years of experience</p>
                                <div className="d-flex justify-content-center flex-wrap gap-2 mb-3">
                                    <span className="badge bg-light text-dark">KubeFlow</span>
                                    <span className="badge bg-light text-dark">Docker + Kubernetes</span>
                                    <span className="badge bg-light text-dark">MLflow</span>
                                </div>
                                <ul className="list-unstyled text-start small m-0">
                                    <li>✔ AWS Certified DevOps Engineer – Professional</li>
                                    <li>✔ Certified Kubernetes Administrator</li>
                                </ul>
                            </div>
                        </div>
                        {/* Team Card 4 */}
                        <div className="col-md-4">
                            <div className="hire-page-team-section-card p-4 bg-white shadow-sm text-center h-100">
                                <img src="/images/home-page-icons/female-avatar.png" alt="Gabriela M." className="rounded-circle mb-3" />
                                <h5 className="fw-bold">Sr. Data Scientist</h5>
                                <p className="text-muted mb-1">Gabriela M.</p>
                                <p className="text-secondary small mb-3">9 years of experience</p>
                                <div className="d-flex justify-content-center flex-wrap gap-2 mb-3">
                                    <span className="badge bg-light text-dark">Scikit-learn</span>
                                    <span className="badge bg-light text-dark">Jupyter Notebook</span>
                                    <span className="badge bg-light text-dark">XGBoost</span>
                                </div>
                                <ul className="list-unstyled text-start small m-0">
                                    <li>✔ Microsoft Certified Azure Data Scientist Associate</li>
                                    <li>✔ IBM Data Science Professional Certificate</li>
                                </ul>
                            </div>
                        </div>
                        {/* Team Card 5 */}
                        <div className="col-md-4">
                            <div className="hire-page-team-section-card p-4 bg-white shadow-sm text-center h-100">
                                <img src="/images/home-page-icons/male-avatar.png" alt="Marco H." className="rounded-circle mb-3" />
                                <h5 className="fw-bold">Sr. AI/ML Architect</h5>
                                <p className="text-muted mb-1">Marco H.</p>
                                <p className="text-secondary small mb-3">13 years of experience</p>
                                <div className="d-flex justify-content-center flex-wrap gap-2 mb-3">
                                    <span className="badge bg-light text-dark">TFX</span>
                                    <span className="badge bg-light text-dark">Terraform</span>
                                    <span className="badge bg-light text-dark">Vertex</span>
                                </div>
                                <ul className="list-unstyled text-start small m-0">
                                    <li>✔ AWS Certified Machine Learning – Specialty</li>
                                    <li>✔ Microsoft Azure Solutions Architect Expert</li>
                                </ul>
                            </div>
                        </div>
                        {/* Right Side CTA Box */}
                        <div className="col-md-4">
                            <div className="hire-page-team-section-cta p-4 bg-success-subtle text-center h-100 d-flex flex-column justify-content-center">
                                {/* <div className="d-flex justify-content-center mb-3">
                                    <img src="https://via.placeholder.com/120x30" alt="team icons" />
                                </div> */}
                                <h5 className="fw-bold mb-3">Onboard a machine learning team<br />in weeks, not months.</h5>
                                <Button text='Talk to an expert' link='https://calendly.com/bitsclan-it/30min' newTab className='w-100' />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default NewTeamSection